import { FC } from "react";
import BookmarkCard from "../BookmarkCard";
import { ICrystalConfig } from "../../data/interface";
import styles from "./index.module.css";

const CrystalCard: FC<ICrystalConfig> = ({ feature, details, link }) => {
  return (
    <BookmarkCard title="Firewalla Crystal (Dev in progress)" titleAlign="right" learnMoreLink={link}>
      <div className={styles.body}>
        <div className={styles.content}>
          <h3 className={styles.title}>{feature}</h3>
          <ol className={styles.features}>
            {details.map((detail, index) => {
              return (
                <li key={index}>
                  <img src="/images/personal-feature-check.svg" alt="Check" />
                  <span>{detail}</span>
                </li>
              );
            })}
          </ol>
        </div>
        <img className={styles.image} src="/images/crystal-hero.png" alt="Firewalla Crystal" />
      </div>
    </BookmarkCard>
  );
};

export default CrystalCard;
